// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var DocumentType;
(function (DocumentType) {
    DocumentType["ServiceRequestForm"] = "SRF";
    DocumentType["Correspondence"] = "COR";
    DocumentType["Income"] = "INC";
    DocumentType["Claim"] = "CLM";
    DocumentType["Enrollment"] = "ENR";
    DocumentType["PriorAuth"] = "PA";
    DocumentType["Other"] = "OTHER";
    DocumentType["AssignmentOfBenefits"] = "AOB";
})(DocumentType || (DocumentType = {}));
//# sourceMappingURL=documentType.js.map